import _ from 'lodash';

import { MaybeUndef } from '../../types/system';
import { StoreState } from '../reducers/store.types';

import {
  SortDirection,
  SortedColumns,
  TableSorting,
} from './sorted-columns.reducer';

export const getColumnsSorting = (state: StoreState) => state.columnsSorting;

export const getTableSorting = (
  sorting: SortedColumns,
  tableName: string,
): MaybeUndef<TableSorting> => _.get(sorting, tableName);

export const getColumnSortDirection = (
  sorting: SortedColumns,
  tableName: string,
  columnName: string,
): MaybeUndef<SortDirection> => {
  const tableSorting = getTableSorting(sorting, tableName);
  return tableSorting && tableSorting.columnName === columnName
    ? tableSorting.direction
    : undefined;
};
